import User from '@/utils/user.js';

import teamService from '@/services/API/team/index';

import { rHandler } from '@/plugins/RHandler';
import { TEAM_TYPES } from '@/modules/Team/constants';
import { ROLES } from '@/constants/roles';

import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import TeamModel from '../list/team';
import Participant from '../list/participant';
import TeamEventRequest from '../list/team-event-request';
import TeamEvent from '../list/team-event';

const URL_TEAM_EVENT_REQUESTS = 'request-team-member-lists';

export const TeamManager = {
  get objects() {
    const BY_ROLE = {
      [ROLES.certificate]: this[TEAM_TYPES.friends],
      [ROLES.member]: this[TEAM_TYPES.friends],
      [ROLES.trainer]: this[TEAM_TYPES.coaching],
      [ROLES.organization]: this[TEAM_TYPES.stage],
    };
    const user = new User();
    const [role] = user.roles;
    if (!role) throw new Error('Manager does not exist for current user role');
    return {
      ...BY_ROLE[role.name],

      getParticipants({ args = [], params } = DEFAULT_PARAMS) {
        const [id] = args;
        return rHandler(
          teamService.getStageParticipants(id, params),
          (response) => ({
            response,
            items: response.data.data.map((i) => new Participant(i, 'users')),
          }),
          (error) => ({ error }),
        );
      },

      get requests() {
        /**
         * !!! Заявки команд от Тренера
         * expand=event,nomination,owner,members,comment,team,avatar
         * search[request_status]
         * search[team_id]
         */
        const baseRequests = objectsRHandler(URL_TEAM_EVENT_REQUESTS, TeamEventRequest);

        const index = async (params, expandMembers = false) => {
          const data = await baseRequests.index(params);
          if (expandMembers && data.items) {
            await Promise.all(data.items.map((request) => request.fetchMembersProfiles()));
          }
          return data;
        };

        const show = async (params, expandMembers = false) => {
          const data = await baseRequests.show(params);
          if (expandMembers && data.items) {
            await Promise.all(data.items.map((request) => request.fetchMembersProfiles()));
          }
          return data;
        };

        return {
          ...baseRequests,
          index,
          show,
        };
      },
    };
  },

  [TEAM_TYPES.stage]: {
    ...objectsRHandler(TEAM_TYPES.stage, TeamModel),

    /**
     * Получить список команд, относящихся к текущему пользователю в зависимости от роли
     *
     * @param { params: object } params параметры запроса
     * @returns { TeamModel[] } массив объектов команд
     */
    getTeams({ params } = DEFAULT_PARAMS) {
      return rHandler(
        teamService.getStageTeams(params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new TeamModel(i, TEAM_TYPES.stage)),
        }),
      );
    },
    getEventTeams({ args } = DEFAULT_PARAMS) {
      const [id, params] = args;
      return rHandler(
        teamService.getTeams(id, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new TeamEvent(i, TEAM_TYPES.stage)),
        }),
      );
    },
    myTeams({ params } = DEFAULT_PARAMS) {
      const user = new User();
      return rHandler(
        teamService.getStageTeams({ ...params, 'search[assign_user_id]': user.data.id }),
        (response) => ({
          response,
          items: response.data.data.map((i) => new TeamModel(i, TEAM_TYPES.stage)),
        }),
      );
    },
  },
  [TEAM_TYPES.friends]: {
    ...objectsRHandler(TEAM_TYPES.friends, TeamModel),

    /**
     * Получить список команд, относящихся к текущему пользователю в зависимости от роли
     *
     * @param { params: object } params параметры запроса
     * @returns { TeamModel[] } массив объектов команд
     */
    myTeams({ params } = DEFAULT_PARAMS) {
      return rHandler(
        teamService.getFriendsTeams(params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new TeamModel(i, TEAM_TYPES.friends)),
        }),
      );
    },
  },
  [TEAM_TYPES.coaching]: {
    ...objectsRHandler(TEAM_TYPES.coaching, TeamModel),

    /**
     * Получить список команд, относящихся к текущему пользователю в зависимости от роли
     *
     * @param { params: object } params параметры запроса
     * @returns { TeamModel[] } массив объектов команд
     */
    myTeams({ params } = DEFAULT_PARAMS) {
      return rHandler(
        teamService.coachingMyTeams(params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new TeamModel(i, TEAM_TYPES.coaching)),
        }),
      );
    },
  },
};
